import $ from 'jquery';
import React from 'react';
import OptionPopupView from "views/common/OptionPopupView";
import { createRoot } from "react-dom/client";
import { GuestInviteContent } from '../../components/guest/GuestInviteContent';

const GuestInvitePopupView = OptionPopupView.extend({

    "pageName": "Guest Invite Popup",

    initialize: function(options) {
        this._mode = options.mode;
        this._currentGuestEmail = options.currentGuestEmail;
        this._currentGuestName = options.currentGuestName;
        this._accessLevel = options.accessLevel;
        this._canSwap = options.canSwap;
        this._onInvite = options.onInvite;
        this._onRevoke = options.onRevoke;
        this._i18nModule = options.i18nModule;
        this._reactRoot = null;

        // Create content container for React component
        this.contentContainer$el = $('<div class="guest-invite-popup-content"></div>');
        this.contentContainer$el.css("width", "calc(100% - 40px)");
        this.contentContainer$el.css("max-width", "500px");

        // Configure OptionPopupView
        const contentView = {};
        contentView.$el = this.contentContainer$el;

        const viewOptions = {
            contentView: contentView,
            contentPosition: "text-not-white",
            addContentAfterEnhancement: true,
            displayTitle: false,
            id: "GuestInvitePopup"
        };

        OptionPopupView.prototype.initialize.call(this, viewOptions);
    },

    onPopupClosed: function() {
        if (this._reactRoot) {
            this._reactRoot.unmount();
            this._reactRoot = null;
        }
    },

    onInviteTriggered: async function(email, accessLevel) {
        if (this._onInvite) {
            await this._onInvite(email, accessLevel);
        }
        this.close();
    },

    onRevokeTriggered: async function() {
        if (this._onRevoke) {
            await this._onRevoke();
        }
        this.close();
    },

    onCancelTriggered: function() {
        this.close();
    },

    addReactWidget: function() {
        // Unmount existing component if any
        if (this._reactRoot) {
            this._reactRoot.unmount();
        }

        // Create new React root and render component
        const root = createRoot(this.contentContainer$el.get(0));

        root.render(
            React.createElement(GuestInviteContent, {
                mode: this._mode,
                currentGuestEmail: this._currentGuestEmail,
                currentGuestName: this._currentGuestName,
                accessLevel: this._accessLevel,
                canSwap: this._canSwap,
                onInvite: this.onInviteTriggered.bind(this),
                onRevoke: this.onRevokeTriggered.bind(this),
                onClose: this.onCancelTriggered.bind(this),
                i18nModule: this._i18nModule
            })
        );

        this._reactRoot = root;
    },

    onAfterPageShow: function() {
        // Render React component after popup is shown
        this.addReactWidget();
    },

    afterRender: function() {
        OptionPopupView.prototype.afterRender.call(this);
    }
});

export default GuestInvitePopupView;
